import { render, staticRenderFns } from "./table_item.vue?vue&type=template&id=8be108ba&scoped=true&lang=pug"
import script from "./table_item.vue?vue&type=script&lang=js"
export * from "./table_item.vue?vue&type=script&lang=js"
import style0 from "./table_item.vue.css?vue&type=style&index=0&id=8be108ba&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be108ba",
  null
  
)

export default component.exports